import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cad-top",
  "use": "icon-cad-top-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cad-top\">\r\n<circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#202020\" />\r\n<path d=\"M4.5 7.5L8 4L11.5 7.5\" stroke=\"white\" />\r\n<rect x=\"7.75\" y=\"4.25\" width=\"0.5\" height=\"7.5\" fill=\"white\" stroke=\"white\" stroke-width=\"0.5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol